import * as React from 'react';
import {Invoice} from '../api/dtos/dtos';

interface Props {
  invoice: Invoice;
}

class InvoiceExternalLink extends React.Component<Props, {}> {
  public render(): React.ReactNode {
    const {invoice} = this.props;

    if (invoice.customerUrl && invoice?.externalNumber) {
      return <a href={invoice.customerUrl} target="_blank" rel="noopener noreferrer">
        {invoice.externalNumber}
      </a>
    }

    return <span>{invoice.externalNumber ?? invoice.internalNumber}</span>
  }
}

export default InvoiceExternalLink;


// WEBPACK FOOTER //
// ./src/invoicing/InvoiceExternalLink.tsx